import type { NotificationData } from '../api/notifications.api';

interface Props {
  notification: NotificationData;
  onMarkRead: (id: string) => void;
}

function getIcon(type: NotificationData['type']): string {
  switch (type) {
    case 'FRIEND_REQUEST':
      return '👤';
    case 'FRIEND_ACCEPTED':
      return '🤝';
    case 'INCOMING_FUNDS':
      return '💰';
    case 'PAYMENT_MADE':
      return '✅';
    case 'PAYOUT_SOON':
      return '📅';
    case 'INFO':
      return 'ℹ️';
    default:
      return '🔔';
  }
}

function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function NotificationItem({ notification, onMarkRead }: Props) {
  const handleClick = () => {
    if (!notification.read) {
      onMarkRead(notification.id);
    }
  };

  return (
    <button
      className={`notification-item ${notification.read ? 'notification-item--read' : 'notification-item--unread'}`}
      onClick={handleClick}
      type="button"
    >
      <span className="notification-item__icon" aria-hidden="true">
        {getIcon(notification.type)}
      </span>
      <div className="notification-item__content">
        <p className="notification-item__title">{notification.title}</p>
        <p className="notification-item__body">{notification.body}</p>
        <time className="notification-item__time" dateTime={notification.deliverDate ?? notification.createdAt}>
          {formatRelativeTime(notification.deliverDate ?? notification.createdAt)}
        </time>
      </div>
      {!notification.read && <span className="notification-item__dot" aria-label="Unread" />}
    </button>
  );
}
